import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule, HttpClient } 	from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Providers
import { Connectivity }         from '../providers/connectivity_provider';
import { LocalStorageService}   from '../providers/localStorage.service';
import { API }                  from '../providers/api';
import { MessagePresenter }     from "../providers/message.service";

// Services
import { UpdateService }    from '../services/update.service';
import { environment }      from 'src/environments/environment';

@NgModule({
  declarations: [AppComponent],
  imports: [HttpClientModule, BrowserModule, IonicModule.forRoot({backButtonText: ''}), AppRoutingModule, 
    ServiceWorkerModule.register('ngsw-worker.js', {
    enabled: environment.production,
    // Register the ServiceWorker as soon as the application is stable
    // or after 30 seconds (whichever comes first).
    registrationStrategy: 'registerWhenStable:30000'
  })
  
    ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, UpdateService,
                Connectivity, LocalStorageService, API, MessagePresenter, Storage],
  bootstrap: [AppComponent],
})

export class AppModule {}
